export * from './dashboard';
export * from './equipments';
export * from './invoice';
export * from './reports';
export * from './service-order';
export * from './service-order-management';
export * from './service-providers';
export * from './services';
export * from './supervisor';

export * from './panel.component';
